import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "edit-orientation"
}
const _hoisted_2 = { class: "samples" }
const _hoisted_3 = {
  key: 0,
  class: "sample more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_RotateLeftIcon = _resolveComponent("RotateLeftIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_RotateRightIcon = _resolveComponent("RotateRightIcon")!
  const _component_FlipHorizontalIcon = _resolveComponent("FlipHorizontalIcon")!
  const _component_NcActions = _resolveComponent("NcActions")!

  return (_ctx.samples.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.t(
        'memories',
        'This feature rotates images losslessly by updating the EXIF metadata. This approach is known to sometimes not work correctly on certain image types such as HEIC. Make sure you do a test run before using it on multiple images.',
      )) + " ", 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samples, (src) => {
            return (_openBlock(), _createBlock(_component_XImg, {
              class: "sample",
              key: src,
              src: src,
              style: _normalizeStyle({ transform: _ctx.transform })
            }, null, 8, ["src", "style"]))
          }), 128)),
          (_ctx.photos.length > _ctx.samples.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", null, "+" + _toDisplayString(_ctx.photos.length - _ctx.samples.length), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_NcActions, {
          inline: 3,
          class: "actions"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NcActionButton, {
              "aria-label": _ctx.t('memories', 'Rotate Left'),
              title: _ctx.t('memories', 'Rotate Left'),
              disabled: _ctx.disabled,
              onClick: _ctx.doleft
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_RotateLeftIcon, { size: 22 })
              ]),
              _: 1
            }, 8, ["aria-label", "title", "disabled", "onClick"]),
            _createVNode(_component_NcActionButton, {
              "aria-label": _ctx.t('memories', 'Rotate Right'),
              title: _ctx.t('memories', 'Rotate Right'),
              disabled: _ctx.disabled,
              onClick: _ctx.doright
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_RotateRightIcon, { size: 22 })
              ]),
              _: 1
            }, 8, ["aria-label", "title", "disabled", "onClick"]),
            _createVNode(_component_NcActionButton, {
              "aria-label": _ctx.t('memories', 'Flip'),
              title: _ctx.t('memories', 'Flip'),
              disabled: _ctx.disabled,
              onClick: _ctx.doflip
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_FlipHorizontalIcon, { size: 22 })
              ]),
              _: 1
            }, 8, ["aria-label", "title", "disabled", "onClick"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}